import { getTrackingAttributes, TRACKING_CATEGORIES } from '../../configuration/setup/googleAnalytics';
import { FormattedMessage } from 'react-intl';
import Button from '@rio-cloud/rio-uikit/Button';
import ButtonToolbar from '@rio-cloud/rio-uikit/ButtonToolbar';

type FooterStepTwoProps = {
    onCopyInvitationClick: () => void;
    onEmailInvitationClicked: () => void;
};

const FooterStepTwo = ({ onCopyInvitationClick, onEmailInvitationClicked }: FooterStepTwoProps) => (
    <ButtonToolbar alignment='right'>
        <Button
            onClick={onCopyInvitationClick}
            iconName='link'
            {...getTrackingAttributes({
                trigger: 'click',
                category: TRACKING_CATEGORIES.INVITATION,
                action: 'Copy invitation link clicked',
                label: 'Copy invitation link clicked',
            })}
        >
            <FormattedMessage id='intl-msg:network.addPartner.copyInvitationLink' />
        </Button>
        <Button
            bsStyle='primary'
            type='submit'
            onClick={onEmailInvitationClicked}
            iconName='envelope'
            {...getTrackingAttributes({
                trigger: 'click',
                category: TRACKING_CATEGORIES.INVITATION,
                action: 'Send email invitation button clicked',
                label: 'Send email invitation button clicked',
            })}
        >
            <FormattedMessage id='intl-msg:network.label.sendEmailInvitation' />
        </Button>
    </ButtonToolbar>
);
export default FooterStepTwo;
